import { PayloadRequest } from 'types/requestTypes'
import { omdApi } from '../../api'

import { } from '../types/cashFlow'
import { CashFlowIncomeSellingDetailItem, CashFlowIncomeSellingItem, CashFlowIncomeSellingRequest } from '../types/cashFlowIncomeSelling'

const cashFlowSchemas = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowIncomeSelling: builder.query<CashFlowIncomeSellingItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeSelling/${data.id}`,
      }),
    }),
    changeCashFlowIncomeSelling: builder.mutation<void, PayloadRequest & CashFlowIncomeSellingItem>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeSelling/${data.id}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowIncomeSelling: builder.mutation<void, CashFlowIncomeSellingItem>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeSelling`,
        method: 'POST',
        body: data
      }),
    }),

    getCashFlowIncomeSellingDetailList: builder.query<CashFlowIncomeSellingDetailItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeSelling/${data.id}/details`,
      }),
    }),
    getCashFlowIncomeSellingDetail: builder.query<CashFlowIncomeSellingDetailItem, CashFlowIncomeSellingRequest>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeSelling/${data.cashFlowId}/details/${data.detailId}`,
      }),
    }),
    changeCashFlowIncomeSellingDetail: builder.mutation<void, CashFlowIncomeSellingDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeSelling/${data.cashFlowId}/details/${data.detailId}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowIncomeSellingDetail: builder.mutation<void, CashFlowIncomeSellingDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeSelling/${data.cashFlowId}/details`,
        method: 'POST',
        body: data
      }),
    }),
    deleteCashFlowIncomeSellingDetail: builder.mutation<void, CashFlowIncomeSellingRequest>({
      query: (data) => ({
        url: `/v1/CashFlowIncomeSelling/${data.cashFlowId}/details/${data.detailId}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useChangeCashFlowIncomeSellingMutation,
  useCreateCashFlowIncomeSellingMutation,
  useGetCashFlowIncomeSellingQuery,
  useLazyGetCashFlowIncomeSellingQuery,

  useGetCashFlowIncomeSellingDetailListQuery,
  useGetCashFlowIncomeSellingDetailQuery,
  useLazyGetCashFlowIncomeSellingDetailQuery,
  useDeleteCashFlowIncomeSellingDetailMutation,
  useCreateCashFlowIncomeSellingDetailMutation,
  useChangeCashFlowIncomeSellingDetailMutation,
} =
cashFlowSchemas
